import React from 'react';
import { 
    Dropdown as FlowBiteDropdown, 
    DropdownProps as FlowBiteDropdownProps,
    DropdownItem as FlowBiteDropdownItem,
    DropdownItemProps as FlowBiteDropdownItemProps } from 'flowbite-react';
import { dropdownTheme } from '../../styles/themes/dropdown';
export type DropdownProps = FlowBiteDropdownProps & {
    ariaLabel?: string;
    testId?: string;
    children: React.ReactNode;
};

export const Dropdown: React.FC<DropdownProps> = (props) => {
    const { ariaLabel, testId, children, ...otherProps } = props;
    return (
        <FlowBiteDropdown data-testid={testId} aria-label={ariaLabel} theme={dropdownTheme} {...otherProps}>
            {children}
        </FlowBiteDropdown>
    );
};

export type DropdownItemProps = FlowBiteDropdownItemProps & {
    ariaLabel?: string;
    testId?: string;
    children: React.ReactNode;
};

export const DropdownItem: React.FC<DropdownItemProps> = (props) => {
    const { ariaLabel, testId, children, ...otherProps } = props;
    return (
        <FlowBiteDropdownItem data-testid={testId} aria-label={ariaLabel} {...otherProps}>
            {children}
        </FlowBiteDropdownItem>
    );
};
